import "./styles.css";
import { Blob } from "react-blob";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tw, setup } from "twind";
import { useState } from "react";
import delay from "lodash.delay";

const colors = {
  "1A": "#AE5D55",
  "1B": "#5C3131",
  "2A": "#C0B9A1",
  "2B": "#97917C",
  "3A": "#E2D6D7",
  "3B": "#786374",
  "4A": "#BD625F",
  "4B": "#903043",
  "5A": "#865857",
  "5B": "#2D212A",
  "6A": "#501B23",
  "6B": "#7A9FA9",
  "7A": "#E2C2A2",
  "7B": "#AD8A76",
  "8A": "#BB7335",
  "8B": "#BA5F48",
  "9A": "#A48278",
  "9B": "#41393D",
  "10A": "#D97697",
  "10B": "#92214D",
  "11A": "#DACDD2",
  "11B": "#3A3146",
  "12A": "#F6BCA0",
  "12B": "#BA493D",
  "13A": "#3D3A46",
  "13B": "#C57769",
  "14A": "#B68B86",
  "14B": "#83605C",
  "15A": "#C0A48E",
  "15B": "#6F624D",
  "16A": "#FCF5F3",
  "16B": "#E3D6DA",
  "17A": "#61403F",
  "17B": "#4B3436",
  "18A": "#AD5955",
  "18B": "#482627",
  "19A": "#C0AFC3",
  "19B": "#BD86B8",
  "20A": "#DA9D83",
  "20B": "#732925",
  "21A": "#EED1B4",
  "21B": "#D8AC8F",
};

setup({
  theme: {
    gradientColorStops: {
      ...colors,
    },
    extend: {
      colors,
    },
  },
});

function pairs(initialArray) {
  return initialArray.reduce(function (result, value, index, array) {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  }, []);
}

function getCopyText(from, to) {
  return `linear-gradient(45deg,${colors[from]},${colors[to]})`;
}

function Gradient({ from, onClick, to }) {
  return (
    <CopyToClipboard onCopy={onClick} text={getCopyText(from, to)}>
      <Blob
        className={tw`hover:shadow-2xl shadow m-4 bg-gradient-to-r from-${from} to-${to} h-64 w-64`}
        data-clipboard-text={`
        `}
      >
        <div className={tw`rounded-lg rounded-lg h-max w-1/2 p-4 bg-white`}>
          {[from, to].map((x) => (
            <div key={x} className={tw`text-${x}`}>
              {colors[x]}
            </div>
          ))}
        </div>
      </Blob>
    </CopyToClipboard>
  );
}

export default function App() {
  const [hasCopied, setHasCopied] = useState(false);

  function handleClick() {
    setHasCopied(true);

    delay(() => {
      setHasCopied(false);
    }, 1000);
  }

  return (
    <div className="App">
      {hasCopied && (
        <div
          className={`${tw`-m-8 mb-8 py-4 w-screen h-max text-xl bg-green-500 text-white`} animate`}
        >
          Copied to clipboard!
        </div>
      )}
      <h1 className={tw`text-4xl`}>Natural Gradients</h1>
      <h2 className={tw`text-2xl`}>
        Created by <a href="https://www.michaelmang.dev/">Mike Mangialardi</a>
      </h2>

      <div className={tw`flex flex-wrap p-8`}>
        {pairs(Object.keys(colors)).map((colorPair) => (
          <Gradient
            from={colorPair[0]}
            to={colorPair[1]}
            onClick={handleClick}
          />
        ))}
      </div>
    </div>
  );
}
